"use client";

import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { useMotion } from "@/contexts/MotionContext";
import { Cog6ToothIcon } from "@heroicons/react/24/outline";
import ThemeToggle from "../ThemeToggle";

export function SettingsButton() {
  const [isOpen, setIsOpen] = useState(false);
  const { isMotionEnabled, toggleMotion } = useMotion();

  return (
    <div className="relative">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="fixed bottom-4 right-4 z-50 flex items-center justify-center w-10 h-10 rounded-full bg-white dark:bg-gray-800 shadow-lg hover:scale-110 transition-transform"
        aria-label="Settings"
      >
        <Cog6ToothIcon className="w-5 h-5" />
      </button>

      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 20 }}
            className="fixed bottom-16 right-4 mb-2 p-4 bg-white dark:bg-gray-800 rounded-lg shadow-lg min-w-[200px]"
          >
            <div className="space-y-4">
              <div className="flex items-center justify-between gap-4">
                <span className="text-sm">Theme</span>
                <ThemeToggle />
              </div>

              <div className="flex items-center justify-between gap-4">
                <span className="text-sm">Animations</span>
                <button
                  onClick={toggleMotion}
                  className={`
                    px-3 py-1 rounded-full text-sm
                    ${
                      isMotionEnabled
                        ? "bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-100"
                        : "bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-100"
                    }
                  `}
                >
                  {isMotionEnabled ? "On" : "Off"}
                </button>
              </div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}
